export default __webpack_public_path__ + "img/ebc509f572fae709953260dbdface385.svg";